module.exports = new __parcel__URL__("grand-theft-auto-san-andreas.f5f0e8d2.jpg").toString();